//
import ProductModel from "@/models/Warehouse/WhProduct"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
export default [
    {
        name: "g_user_id",
        props: {
            chips: true,
            itemText: "full_name",
            itemValue: "id",
            label: "Responsable",
            model: UserModel,
            noObject: true,
        },
        type: "autocomplete-model"
    },
    {
        name: "wh_item_to_repackage_id",
        props: {
            itemText: "name",
            itemValue: "wh_item_id",
            label: "Producto",
            model: ProductModel,
            noModeler: true,
            noObject: true,
        },
        type: "autocomplete-model"
    },
    {
        name: "wh_warehouse_from_id",
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Origen",
            model: WarehouseModel,
            noObject: true,
        },
        type: "autocomplete-model"
    },
    {
        name: "wh_warehouse_to_id",
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Destino",
            model: WarehouseModel,
            noObject: true,
        },
        type: "autocomplete-model"
    },
]